module.exports = __webpack_public_path__ + "img/login.a04c5130.svg";